import { Pipe, PipeTransform } from '@angular/core';
import { Aggregator } from '@liberty-financial/agp-shared';

import { aggregator } from '@env/aggregator/aggregator';

export enum AdviserLabelCase {
  TitleCase = 'TitleCase',
  LowerCase = 'LowerCase'
}

@Pipe({
  name: 'adviserLabel'
})
export class AdviserLabelPipe implements PipeTransform {
  transform(advicerLabelCase: AdviserLabelCase): string {
    switch (advicerLabelCase) {
      case AdviserLabelCase.TitleCase:
        return aggregator.name === Aggregator.NMB ? 'Broker' : 'Adviser';
      default:
        return aggregator.name === Aggregator.NMB ? 'broker' : 'adviser';
    }
  }
}
